export default __webpack_public_path__ + "static/caramel-eyelet-b651725e215a016e71be98eb9920c6c7.webp";